import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-ng-uikit',
  template: `
    <p>
      ng-uikit works!
    </p>
  `,
  styles: []
})
export class NgUikitComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
